module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-yellow-604c71.svg";